<template>
  <div class="category-section">
    <span class="title">{{ categoryName }}</span>
    <div class="fields">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBarCategory',
  props: {
    categoryName: {
      default: 'insert the category-name',
      type: String
    },
    hasArrow: {
      default: false,
      type: Boolean
    },
    col: {
      type: String,
      default: 'col'
    }
  }
}
</script>

<style lang="stylus" scoped>
.category-section {
  display grid
  grid-template-rows auto 1fr
  grid-gap 10px

  .title {
    font-weight 300
    color #808080
    font-size 12px
    text-transform capitalize
  }

  .fields {
    display grid
    grid-gap 10px
    align-content start
  }
}
</style>
